
import Vue from 'vue';
import Component from 'vue-class-component';
import simpleMixin from './mixin';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ParameterVariableInput',
  mixins: [simpleMixin],
})
export default class ParameterVariableInput extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  schema: any;

  @Prop({
    type: [Object, Array],
    required: true,
  })
  data: any;

  @Prop()
  value: any;

  @Prop({
    type: Object,
    required: false,
  })
  context: any;
}
